import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Table } from 'primeng/table';
import { Anamnese } from 'src/app/admihair/api/dto/anamnese';
import { AnamneseService } from 'src/app/admihair/service/anamnese.service';
import { ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthUtil } from 'src/app/admihair/util/auth-util';

@Component({
  selector: 'app-anamnese-configuracao-listar',
  templateUrl: './anamnese-configuracao-listar.component.html',
  styleUrls: ['./anamnese-configuracao-listar.component.scss']
})
export class AnamneseConfiguracaoListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  listaAnamneses: Anamnese[] = [];
  loadingTable: boolean = false;


  constructor(private anamneseService: AnamneseService,
    private confirmationService: ConfirmationService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    super(erroService, storageService, router, activatedRoute)
   }

  ngOnInit(): void {
    this.verificarPermissoes();
    if (this.permissaoListar) {
      this.carregarAnamneses();
    }
  }

  carregarAnamneses() {
    this.loadingTable = true;
    this.anamneseService.listarPorEmpresa(this.getEmpresa().id).subscribe({
      next: (data: Anamnese[]) => {
        this.listaAnamneses = data;
        this.loadingTable = false;
      },
      error: (err: any) => {
        this.loadingTable = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  excluir(id?: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.anamneseService.excluir(id).subscribe({
          next: () => {
            this.carregarAnamneses();
            this.exibirMensagemSucesso();
          },
          error: (err: any) => {
            this.loadingTable = false;
            this.exibirMensagemErro(err);
          }
        })
      }
    });
  }


  buscar(table: Table, event: Event) {
      table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }
  
    limpar(table: Table) {
      table.clear();
      this.filter.nativeElement.value = '';
    }

    verificarPermissoes() {
        this.permissaoListar = AuthUtil.verificarPermissao('PERM_LISTAR_CONFIGURACAO_ANAMNESE');
        this.permissaoInserir = AuthUtil.verificarPermissao('PERM_INSERIR_CONFIGURACAO_ANAMNESE');
        this.permissaoEditar = AuthUtil.verificarPermissao('PERM_EDITAR_CONFIGURACAO_ANAMNESE');
        this.permissaoExcluir = AuthUtil.verificarPermissao('PERM_EXCLUIR_CONFIGURACAO_ANAMNESE');
      }

}
